import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";
import { useAuth } from "./auth";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const { user } = useAuth();
  const [cart, setCart] = useState({ items: [], total: 0 });

  const refresh = useCallback(async () => {
    if (!user) {
      setCart({ items: [], total: 0 });
      return;
    }
    try {
      const { data } = await api.get("/cart");
      setCart(data);
    } catch {
      setCart({ items: [], total: 0 });
    }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const add = async (pid) => { await api.post(`/cart/add/${pid}`); await refresh(); };
  const remove = async (pid) => { await api.post(`/cart/remove/${pid}`); await refresh(); };

  return (
    <CartContext.Provider value={{ cart, refresh, add, remove }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
